import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/browser-deeplink.js";

var SmartBanner = function (options) {
    this.options = $.extend({}, $.smartbanner.defaults, options);
    var banner = '<div id="smartbanner" class="banner"><div class="sb-container"><a href="#" class="sb-close"></a><span class="sb-icon"></span><div class="sb-info"><strong>' + this.options.title + '</strong></div><a href="#" class="sb-button"><span>' + this.options.buttonText + '</span></a></div></div>';
    if (HsnDrdPageCache.getCookie('bnrhid')) {
        return;
    }

    $('#utility-nav-parent, #utility-nav-parent-v3').append(banner);
    this.bannerHeight = $('#smartbanner').outerHeight() + 2;
    this.Show();
    this.BindEvents();

    deeplink.setup({
        iOS: {
            appName: this.options.appName,
            appId: this.options.appId,
        },
        android: {
            appId: this.options.appId
        }
    });
};

SmartBanner.prototype = {
    constructor: SmartBanner,

    Show : function() {
        var scope = this;
        var banner = $('#smartbanner');
        banner.animate({ top: 0, display: 'block' }, this.options.speedIn).addClass('shown').show();
        if(this.options.timeout) {
            window.setTimeout(function() {
                scope.Close();
            }, this.options.timeout);
        }
    },
    Hide: function() {
        var banner = $('#smartbanner');
        banner.animate({ top: -1 * this.bannerHeight, display: 'block' }, this.options.speedIn).removeClass('shown');
    },
    Close: function () {
        this.Hide();
        HsnDrdPageCache.setCookie('bnrhid', true, HsnDrdPageCache.getLowerDomain(), this.options.daysHidden, '/');
        return false;
    },
    BindEvents: function() {
        $('#smartbanner .sb-close').on('click', $.proxy(this.Close, this));
        $('#smartbanner .sb-button').on('click', $.proxy(this.OpenApp, this));
    },
    OpenApp: function () {
        var scope = this;
        scope.coremetricsLinkClick('banner-_-MobileApp-_-NA');
        this.SendDeepLinkData(function() {
            deeplink.open(scope.options.deepLinkUrl);
            scope.Hide();
            HsnDrdPageCache.setCookie('bnrinst', true, HsnDrdPageCache.getLowerDomain(), scope.options.daysReminder, '/');
        });
        return false;
    },
    SendDeepLinkData: function (callback) {
        var data = { deepLink : this.options.deepLinkUrl }
        $.ajax ( '/api/save-deep-link', {
                type: 'POST',
                data: data,
                context: this,
                dataType: 'json',
                success: function () {
                    if (callback)
                        callback.call();
                },
            }
        );
    },
    coremetricsLinkClick: function(cmData) {
        cmCreateManualLinkClickTag(window.location.href + '?cm_re=' + cmData + '&amp;cm_sp=' + cmData, 'DeepLink');
    }
};
$.smartbanner = function(option) {
    var $window = $(window),
        data = $window.data('smartbanner'),
        options = typeof option == 'object' && option;
    if(!data)
        $window.data('smartbanner', (data = new SmartBanner(options)));
    if(typeof option == 'string')
        data[option]();
};
// override these globally if you like (they are all optional)
$.smartbanner.defaults = {
    title: null, // What the title of the app should be in the banner (defaults to <title>)
    buttonText: 'OPEN', // Text for the install button
    speedIn: 300, // Show animation speed of the banner
    speedOut: 400, // Close animation speed of the banner
    daysHidden: 90, // Duration to hide the banner after being closed (0 = always show banner)
    daysReminder: 0, // Duration to hide the banner after "VIEW" is clicked *separate from when the close button is clicked* (0 = always show banner)
    appendToSelector: '#utility-nav-parent, #utility-nav-parent-v3', //Append the banner to a specific selector
    appName: 'HSN Shop App',
    appId: '324326909',
    deepLinkUrl: 'hsnapp://',
    timeout: null
}


// WEBPACK FOOTER //
// ./assets/js/HSN/SmartBanner.js